import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './SearchResults.css';
import { format, parseISO } from 'date-fns';

const SearchResults = ({ results, onEventResultClick, onFilterResultClick }) => {
  const [searchParams] = useSearchParams();

  if (!results || results.length === 0) {
    return null;
  }

  return (
    <ul className="search-results-list">
      {results.map(item => {
        if (item.type === 'filter') {
          return (
            <li key={item.id}>
              <div 
                className="search-result-item filter-suggestion"
                onClick={() => onFilterResultClick(item.value)}
              >
                <span className="result-title">{item.display}</span>
              </div>
            </li>
          );
        } else {
          return (
            <li key={item.id}>
              <Link
                to={`/events/${item.slug}?${searchParams.toString()}`}
                className="search-result-item event-result"
                onClick={onEventResultClick}
              >
                  <span className="result-title">{item.title}</span>
                  {/* Using a robust date format preset 'PP' (e.g., "Jun 19, 2025") */}
                  <span className="result-date">{format(parseISO(item.event_date), 'PP')}</span>
              </Link>
            </li>
          );
        }
      })}
    </ul>
  );
};

export default SearchResults;
